import React from "react";
import styled, { css } from "styled-components";
const StyledDescriptionBox = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.variant.lightest.default};
    border: 1px solid ${theme.colors.variant.lighter.default};
    padding: 10px;
    margin: 5px;
    border-radius: 6px;

    .description {
      padding-bottom: 5px;
      text-transform: uppercase;
    }
  `
);
const DescriptionBox = ({ description, children = void 0 }) => /* @__PURE__ */ React.createElement(StyledDescriptionBox, null, /* @__PURE__ */ React.createElement("div", { className: "description" }, description), children);
export default DescriptionBox;
